<template>
  <b-modal
    id="verify"
    :visible="isVerifyActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    ok-title="Submit Code"
    cancel-disabled
    shadow
    backdrop
    right
    @change="(val) => $emit('update:is-verify-active', val)"
    @ok="handleSubmit"
  >
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
      <h5 class="mb-0">
        Verification Code
      </h5>
    </div>
    <b-form-group
      label="Verification Code"
      label-for="code"
    >
      <b-form-input
        id="code"
        v-model="verifyCode"

        trim
      />
    </b-form-group>
  </b-modal>
</template>

<script>
import { BModal, BFormGroup, BFormInput } from 'bootstrap-vue'
import { Auth } from 'aws-amplify'
// eslint-disable-next-line no-unused-vars
import VueSweetAlert2 from 'vue-sweetalert2'

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
  },
  model: {
    prop: 'isVerifyActive',
    event: 'update:is-verify-active',
  },
  props: {
    isVerifyActive: {
      type: Boolean,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      verifyCode: '',
    }
  },
  methods: {
    async handleSubmit() {
      try {
        // eslint-disable-next-line no-unused-vars
        const response = await Auth.confirmSignUp(this.email, this.verifyCode)

        this.$swal({
          icon: 'success',
          title: 'You are now verified, please login again',
          showConfirmButton: true,
          timer: 5000,
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        this.$emit('login')
        this.$emit('update:is-verify-active', false)
      } catch (error) {
        if (error.code === 'CodeMismatchException') {
          this.$emit('update:is-verify-active', true)
        }
      }
    },
  },
}
</script>

<style>

</style>
